import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { useReportActivityAnalyzeFilters } from 'business/shift-report/report-analyze/pages/activity-analyze/providers/filters';
import config from 'config';
import AppLogo from 'ui/appLogo';

import styles from './index.module.scss';

const ReportActivityAnalyzePrintHeader = () => {
  const { t } = useTranslation();
  const { currentConstructionSite } = useAppContext();
  invariant(currentConstructionSite, 'No constructionSite');

  const name = currentConstructionSite.name;
  const logo = currentConstructionSite.logo;

  const filters = useReportActivityAnalyzeFilters();

  const dates =
    filters.filterType === 'date' &&
    filters.dateRange &&
    filters.dateRange[0] &&
    filters.dateRange[1]
      ? [filters.dateRange[0].format('L'), filters.dateRange[1].format('L')]
      : undefined;

  return (
    <div className={styles.printHeader}>
      <div className="header-left">
        <AppLogo />
        {logo && (
          <AppLogo
            alt="Construction site logo"
            path={`${config.gcp.publicUri}/${logo}`}
          />
        )}
      </div>
      <h1 id="pdfReportPrint">{name}</h1>
      {dates ? (
        <h2>
          {t('pages.print.rangeTitle', {
            startDate: dates[0],
            endDate: dates[1],
          })}
        </h2>
      ) : null}
    </div>
  );
};

export default ReportActivityAnalyzePrintHeader;
